import { useLocation, useNavigate, useParams } from "react-router-dom";
import { languages, normalizeLang, switchLangPath } from "../lib/i18n";

export default function LanguageSwitcher() {
  const { lang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <select className="rounded-md border border-slate-200 bg-white px-2 py-2 text-sm" value={normalizeLang(lang)} onChange={(e) => navigate(switchLangPath(location.pathname, e.target.value as never))}>
      {languages.map((item) => <option key={item.code} value={item.code}>{item.label}</option>)}
    </select>
  );
}
